import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PipesModule } from "../shared/pipes/pipes.module";
import { ComponentsModule } from '../shared/components/components.module';

import { BoardRoutingModule } from './board-routing.module';

import { BoardComponent } from './board.component';
import { BoardListComponent } from './board-list/board-list.component';


@NgModule({
  declarations: [
    BoardComponent,
    BoardListComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    ComponentsModule,
    BoardRoutingModule,
  ]
})
export class BoardModule { }
